






















































































import { Auth } from '@finx/web-repository/src/services/Oidc'

import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import NetPromoterScoreStore from '@/components/NetPromoterScore/Store/NetPromoterScoreStore'
import { timeout } from '@/utils/common'

@Component
export default class ComponentNetPromoterScore extends Vue {
  async created() {
    const user = this.$user
    const notAllowedRoutes = ['FinanceiroUploadNotaFiscal']
    const currentRoute = this.$route.name || ''

    if (user.profile.sub && !notAllowedRoutes.includes(currentRoute) && process.env.NODE_ENV !== 'development') {
      await this.getNetPromoterScoreStore.getNetPromoterScoreQuestion()
    }

    if (
      this.netPromoterScoreData.question
      && this.netPromoterScoreData.question.question
      && this.netPromoterScoreData.question.showQuestion
    ) {
      this.showNetPromoterScoreModal = true
    } else {
      this.showNetPromoterScoreModal = false
    }
  }

  mounted() {
    const modalDialogContainer = this.$refs.netPromoterScoreModal
    let htmlContent: HTMLElement | null = null

    if (!!modalDialogContainer && !!modalDialogContainer.$refs) {
      htmlContent = modalDialogContainer.$refs.content
    }

    if (htmlContent !== null) {
      // @ts-ignore
      htmlContent.querySelector('.v-dialog').setAttribute('data-cy', 'nps')
    }
  }

  @Watch('showNetPromoterScoreModal')
  onNetPromoterScoreModalChange(isActive: boolean) {
    if (isActive) {
      this.setNetPromoterScoreSurveyDefaultLayout()
    }
  }

  netPromoterScoreFormRules: {
    rating: Array<any>;
    valid?: boolean;
  } = {
    rating: [v => !!v || 'Campo obrigatório'],
  }

  $refs: { netPromoterScoreForm: any, netPromoterScoreModal: any }
  ratingIndexHovered: number = -1
  showNetPromoterScoreModal: boolean = false
  cardColor: 'green darken-3' | 'blue darken-3' = 'blue darken-3'
  submitLoading: boolean = false
  showQuestion: boolean = true
  netPromoterScoreFormData: {
    answer: string | null;
    rating: number | null;
  } = { answer: null, rating: null }

  get rating() {
    if (this.netPromoterScoreFormData.rating && this.netPromoterScoreFormData.rating > 0) {
      return this.netPromoterScoreFormData.rating - 1
    }

    return this.netPromoterScoreFormData.rating
  }

  get getNetPromoterScoreStore() {
    return getModule(NetPromoterScoreStore, this.$store)
  }

  get netPromoterScoreData() {
    return {
      question: this.getNetPromoterScoreStore.netPromoterScoreQuestion,
    }
  }

  get showNetPromoterScoreButton(): boolean {
    const notAllowedRoutes: any[] = [
      'inicio',
      'not-found',
      'forbidden',
      'service-unavaliable',
    ]

    return !notAllowedRoutes.includes(this.$route.name)
            && !!this.netPromoterScoreData.question
            && !!this.netPromoterScoreData.question.question
  }

  async dismissNetPromoterScoreSurvey() {
    this.showNetPromoterScoreModal = false

    const answer = {
      id: this.netPromoterScoreData.question.id,
      dismissed: true,
      answer: this.netPromoterScoreFormData.answer,
      rating: this.rating,
    }

    await this.getNetPromoterScoreStore.answerNetPromoterScoreSurvey(answer)

    this.netPromoterScoreFormData = { answer: null, rating: null }
  }

  async answerNetPromoterScoreSurvey() {
    this.$refs.netPromoterScoreForm.validate()

    if (this.netPromoterScoreFormRules.valid) {
      this.submitLoading = true

      const answer = {
        id: this.netPromoterScoreData.question.id,
        dismissed: false,
        answer: this.netPromoterScoreFormData.answer,
        rating: this.rating,
      }

      await this.getNetPromoterScoreStore.answerNetPromoterScoreSurvey(answer)

      this.showQuestion = false
      this.cardColor = 'green darken-3'

      await timeout(2500)

      this.showNetPromoterScoreModal = false
      this.submitLoading = false
      this.netPromoterScoreFormData = { answer: null, rating: null }
    }
  }

  openFeedbackModal() {
    this.showNetPromoterScoreModal = true
  }

  setNetPromoterScoreSurveyDefaultLayout() {
    this.cardColor = 'blue darken-3'
    this.showQuestion = true
  }
}
